import React from "react";
import Loader from "../../../../components/common/Loader";
import Modal2 from "../../../../components/common/Modal/Modal2";
import Input from "../../../../components/common/Input";
import {useToasts} from "react-toast-notifications";
import restService from "../../../../services/restService";
import {useEffect} from "react";
import {useState} from "react";

const keys = ["rate", "destination_currency", "source_currency"];
const AddCommissionModal = ({isAddingID, setShow}) => {
  const {addToast} = useToasts();

  const [form, setForm] = useState({
    agent_id: "",
    agency_id: "",
    agency_percentage: 30,
    agent_percentage: 30,
    company_percentage: 40,
  });
  const [errors, setErrors] = useState({});
  const [agents, setAgents] = useState([]);
  const [agencies, setAgencies] = useState([]);

  const initFormValues = async () => {
    const agencyList = await restService.AgencyApi.getAgencies();
    const agentList = await restService.AgentApi.getAgentsByAgency(
      agencyList.data?.data?.data[0]?.id
    );
    setAgents(agentList.data?.data?.data);
    setAgencies(agencyList.data?.data?.data);

    setForm({
      ...form,
      agency_id: agencyList.data?.data?.data[0]?.id,
      agent_id: agentList.data?.data?.data[0]?.id,
    });
  };

  useEffect(() => {
    initFormValues();
  }, []);

  const validateForm = () => {
    const keys = Object.keys(form);

    let errorList = {...errors};
    keys.forEach((key) => {
      if (form[key] === "" || form[key] === undefined) {
        errorList[key] = "This field is required.";
      }
    });

    if (
      Number(form.agency_percentage) +
        Number(form.agent_percentage) +
        Number(form.company_percentage) !==
      100
    ) {
      errorList.total =
        "Agency, agent, and company Percentage should add up to 100.";
    }
    setErrors(errorList);
    return Object.keys(errorList).length === 0;
  };

  const saveCommission = () => {
    if (validateForm()) {
      restService.CommissionsConfigApi.addCommissionConfiguration(form).then(
        (response) => {
          setForm({
            agency_percentage: 30,
            agent_percentage: 30,
            company_percentage: 40,
          });
          addToast("Successfully Added Commission Configuration", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      );
    }
  };

  const onFormChange = ({target}) => {
    let details = {...form};
    details[target.name] = target.value;
    let errorList = {...errors};

    if (target.name === "agency_id") {
      restService.AgentApi.getAgentsByAgency(target.value).then(({data}) => {
        setAgents(data?.data.data);
        setForm({...details, agent_id: data?.data?.data[0]?.id});
      });

      delete errorList["agent_id"];
    }
    setForm(details);

    delete errorList[target.name];
    delete errorList.total;
    setErrors(errorList);
  };

  const handlePercentageChange = (e) => {
    const {name, value} = e.target;
    const otherPercentage =
      name === "agent_percentage"
        ? form.agency_percentage
        : form.agent_percentage;
    let sum = parseFloat(value) + parseFloat(otherPercentage);

    if (sum < 0) {
      setForm({
        ...form,
        [name]: 0,
        [name === "agent_percentage"
          ? "agency_percentage"
          : "agent_percentage"]: 0,
      });
    } else if (sum > 100) {
      setForm({
        ...form,
        [name]: 100 - otherPercentage,
        [name === "agent_percentage"
          ? "agency_percentage"
          : "agent_percentage"]: otherPercentage,
      });
    } else {
      setForm({...form, [name]: value});
    }
  };

  useEffect(() => {
    setForm({
      ...form,
      company_percentage:
        100 - (Number(form.agency_percentage) + Number(form.agent_percentage)),
    });
  }, [form.agency_percentage_percentage, form.agent_percentage]);

  return (
    <>
      {isAddingID ? <Loader /> : null}
      <Modal2
        onHide={() => {
          setShow(false);
        }}
        size={"lg"}
      >
        <>
          {/* {senderAdded ? (
              <div className="h-[50vh] flex items-center justify-center">
                <Success />
              </div>
            ) : ( */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 min-h-screen p-6">
            <div className="max-w-4xl mx-auto">
              {/* Header */}
              <div className="flex items-center justify-between mb-8">
                <button 
                  onClick={() => setShow(false)}
                  className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  <span className="font-medium">Back</span>
                </button>
              </div>

              {/* Main Card */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                {/* Card Header */}
                <div className="bg-gradient-to-r from-green-600 to-emerald-600 px-8 py-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <div>
                      <h1 className="text-2xl font-bold text-white">Add Commission Configuration</h1>
                      <p className="text-green-100 mt-1">Configure commission splits between parties</p>
                    </div>
                  </div>
                </div>

                {/* Form Content */}
                <div className="p-8">
                  {/* Commission Split Section */}
                  <div className="mb-8">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <svg className="w-5 h-5 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                      </svg>
                      Commission Distribution
                    </h3>
                    
                    {/* Warning about total percentage */}
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                      <div className="flex items-start space-x-2">
                        <svg className="w-5 h-5 text-yellow-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-sm text-yellow-700">
                          <strong>Important:</strong> The total of all percentages must equal 100%. The company percentage will be automatically calculated.
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Agency Percentage */}
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Agency Percentage <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                          </div>
                          <input
                            type="number"
                            min={0}
                            max={100}
                            step="0.01"
                            value={form.agency_percentage}
                            onChange={handlePercentageChange}
                            name="agency_percentage"
                            className={`w-full pl-10 pr-8 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                              errors.agency_percentage ? 'border-red-300 bg-red-50' : 'border-gray-300'
                            }`}
                            placeholder="30.00"
                          />
                          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <span className="text-gray-500 text-sm">%</span>
                          </div>
                        </div>
                        {errors.agency_percentage && (
                          <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.agency_percentage}
                          </p>
                        )}
                      </div>

                      {/* Agent Percentage */}
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Agent Percentage <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                          </div>
                          <input
                            type="number"
                            min={0}
                            max={100}
                            step="0.01"
                            value={form.agent_percentage}
                            onChange={handlePercentageChange}
                            name="agent_percentage"
                            className={`w-full pl-10 pr-8 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 ${
                              errors.agent_percentage ? 'border-red-300 bg-red-50' : 'border-gray-300'
                            }`}
                            placeholder="30.00"
                          />
                          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <span className="text-gray-500 text-sm">%</span>
                          </div>
                        </div>
                        {errors.agent_percentage && (
                          <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.agent_percentage}
                          </p>
                        )}
                      </div>

                      {/* Company Percentage (Auto-calculated) */}
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Company Percentage
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                          </div>
                          <input
                            type="number"
                            value={100 - (Number(form.agency_percentage) + Number(form.agent_percentage))}
                            disabled
                            className="w-full pl-10 pr-8 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-700 cursor-not-allowed"
                          />
                          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <span className="text-gray-500 text-sm">%</span>
                          </div>
                        </div>
                        {errors.company_percentage && (
                          <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.company_percentage}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Total validation error */}
                    {errors.total && (
                      <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4">
                        <div className="flex items-center space-x-2">
                          <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          <p className="text-sm text-red-700 font-medium">{errors.total}</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Assignment Section */}
                  <div className="mb-8">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <svg className="w-5 h-5 text-green-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      Assignment
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Agency <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <select
                            value={form.agency_id}
                            onChange={onFormChange}
                            name="agency_id"
                            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 appearance-none bg-white ${
                              errors.agency_id ? 'border-red-300 bg-red-50' : 'border-gray-300'
                            }`}
                          >
                            <option value="">Select Agency</option>
                            {agencies.map((agency) => (
                              <option key={agency.id} value={agency.id}>{agency.name}</option>
                            ))}
                          </select>
                          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                        {errors.agency_id && (
                          <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.agency_id}
                          </p>
                        )}
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Agent <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <select
                            value={form?.agent_id || ''}
                            onChange={onFormChange}
                            name="agent_id"
                            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-colors duration-200 appearance-none bg-white ${
                              errors.agent_id ? 'border-red-300 bg-red-50' : 'border-gray-300'
                            }`}
                          >
                            <option value="">Select Agent</option>
                            {agents.map((agent) => (
                              <option key={agent.id} value={agent.id}>
                                {agent.firstname} {agent.lastname}
                              </option>
                            ))}
                          </select>
                          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3">
                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                        {errors.agent_id && (
                          <p className="text-red-500 text-sm flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                            {errors.agent_id}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Commission Preview */}
                  {form.agency_percentage && form.agent_percentage && (
                    <div className="mb-8 bg-green-50 border border-green-200 rounded-lg p-4">
                      <div className="flex items-center space-x-2 mb-3">
                        <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                        <h4 className="text-sm font-medium text-green-900">Commission Split Preview</h4>
                      </div>
                      <div className="grid grid-cols-3 gap-4 text-sm">
                        <div className="text-center">
                          <p className="text-green-700 font-medium">Agency</p>
                          <p className="text-green-900 font-bold text-lg">{form.agency_percentage}%</p>
                        </div>
                        <div className="text-center">
                          <p className="text-green-700 font-medium">Agent</p>
                          <p className="text-green-900 font-bold text-lg">{form.agent_percentage}%</p>
                        </div>
                        <div className="text-center">
                          <p className="text-green-700 font-medium">Company</p>
                          <p className="text-green-900 font-bold text-lg">{100 - (Number(form.agency_percentage) + Number(form.agent_percentage))}%</p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="flex justify-end space-x-4 pt-6 border-t border-gray-100">
                    <button
                      onClick={() => setShow(false)}
                      className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={saveCommission}
                      className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white rounded-lg transition-all duration-200 shadow-sm hover:shadow-md font-medium flex items-center space-x-2"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                      <span>Add Commission Configuration</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </Modal2>
    </>
  );
};

export default AddCommissionModal;
